/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';

import { translate } from 'react-i18next';

import { ReactAccessConsumer } from 'react-access';

import styles from './ManageAccount.module.scss';

import { updateDisableEnableAccount } from 'permissions/account';

@translate()
export default class ManageAccount extends React.Component<*> {
  render(): React.Element<*> {
    const disabled = this.props.disabled;

    return (
      <ReactAccessConsumer>
        {authorizeAccess => {
          return (
            <div className={styles['manage-button']}>
              <Link
                to={this.props.to}
                className={
                  disabled && !authorizeAccess(updateDisableEnableAccount)
                    ? styles['is-disabled']
                    : ''
                }
              >
                {this.props.title && (
                  <h3 className={`${styles.title}`} title={this.props.title}>
                    {this.props.title}
                  </h3>
                )}
                {
                  <span className={styles.button}>
                    <svg>
                      <use xlinkHref="#icon-manage" />
                    </svg>
                    {this.props.t('general:actions.manage_account')}
                  </span>
                }
              </Link>
            </div>
          );
        }}
      </ReactAccessConsumer>
    );
  }
}
